import { GetAssetsRequest } from './asset.service.interfaces';

export function makeGetAssetsParams(req?: Partial<GetAssetsRequest>): GetAssetsRequest {
  return {
    ...req,
    $orderBy: req?.$orderBy ?? 'createdAt',
    $order: req?.$order ?? 'desc',
    $page: req?.$page ?? 1,
    $perPage: req?.$perPage ?? 10,
  };
}
